(function () {
  function mountBannerFiveContent() {
    var slide = document.querySelector('#shopify-section-home #anHero.hero .hero-slide:nth-child(5)');
    if (!slide || slide.querySelector('.an-hero-copy-layer--softly')) return;

    var scrim = document.createElement('div');
    scrim.className = 'an-hero-copy-scrim an-hero-copy-scrim--softly';
    scrim.setAttribute('aria-hidden', 'true');

    var layer = document.createElement('div');
    layer.className = 'an-hero-copy-layer an-hero-copy-layer--softly';
    layer.innerHTML = [
      '<div class="an-hero-copy an-hero-copy--softly">',
      '<h2 aria-label="Scents That Speak Softly, Stay Forever">',
      '<span class="an-hero-title-line">Scents That</span>',
      '<span class="an-hero-title-line">Speak Softly,</span>',
      '<span class="an-hero-title-line an-hero-title-accent">Stay Forever</span>',
      '</h2>',
      '<div class="an-hero-description">',
      '<p>At After Note, we don&rsquo;t believe in trends or bestsellers.</p>',
      '<p>We help you discover fragrances that truly reflect your personality, preferences and budget.</p>',
      '</div>',
      '<a class="an-hero-cta an-hero-cta--softly" href="/collections">Explore Collections</a>',
      '</div>'
    ].join('');

    slide.appendChild(scrim);
    slide.appendChild(layer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBannerFiveContent);
  } else {
    mountBannerFiveContent();
  }

  window.addEventListener('pageshow', mountBannerFiveContent);
  document.addEventListener('shopify:section:load', mountBannerFiveContent);
})();
